import type { SearchAlgoliaVolopHit } from 'modules/search/algolia/types/SearchAlgoliaVolopHit';
import { postJson } from 'utils/http/postJson';

type ApiResponse = {
  listing: SearchAlgoliaVolopHit | null;
};

export async function searchApiFetchPromotedListing(latLng: {
  latitude: number | null | undefined;
  longitude: number | null | undefined;
}): Promise<ApiResponse> {
  return postJson('/data/website/promoted-listing-for-search', latLng);
}
